import React from "react";
import SignIn from "../../views/Login/SignIn";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { LogoutOutlined, Shop } from "@mui/icons-material";
import { Person } from "@material-ui/icons";
import MyProfile from "../../views/myProfile/MyProfile";
import Logout from "../../views/logout/Logout";
import UnderDevelopment from "../UnderDevelopment";
import PageNotFound from "../PageNotFound";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import AddTaskIcon from "@mui/icons-material/AddTask";
import GradingIcon from "@mui/icons-material/Grading";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import GroupIcon from "@mui/icons-material/Group";
import InfluencerDashboard from "../../views/influencerDashboard/InfluencerDashboard";
import InfluencersCampaigns from "../../views/influencerCampaigns/InfluencersCampaigns";
import ManageInfluencerUser from "../../views/manageInfluencerUser/ManageInfluencerUser";
import InfluencersAllActivity from "../../views/influencersAllActivity/InfluencersAllActivity";
import InfluencerReports from "../../views/influencerReports/InfluencerReports";
import ActivityTypeList from "../../views/influencerActivityType/ActivityTypeList";
import InfluencersPlatformAccount from "../../views/influencersPlatformAccounts/InfluencersPlatformAccount";
import FacebookCallBack from "../oauth_callback/FacebookCallBack";
import YoutubeCallBack from "../oauth_callback/YoutubeCallBack";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";

const routes = {
  data: [
    //SIGN IN ROUTE DATA
    {
      category: "Auth",
      path: "/",
      element: <SignIn />,
      id: "sign",
      title: "Sign In",
      icon: <InboxIcon />,
      type: "item",
      roles: [],
    },

    // My Profile Page Route Data
    {
      category: "Influencer",
      path: "/myProfile",
      element: <MyProfile />,
      id: "myProfile_id",
      title: "My Profile",
      icon: <Person />,
      type: "item",
      roles: [],
      visibility: "hidden",
      hide: true,
    },

    // Logout Page
    {
      category: "Logout",
      path: "/logout",
      element: <Logout />,
      id: "logout",
      title: "Logout",
      icon: <LogoutOutlined />,
      type: "item",
      roles: [],
    },

    //under development page
    {
      category: "Influencer",
      path: "/underDevelopment",
      element: <UnderDevelopment />,
      id: "underDevelopment",
      title: "Under Development",
      icon: <DoNotDisturbAltIcon />,
      type: "item",
      roles: [],
      visibility: "hidden",
      hide: true,
    },

    {
      category: "Influencer",
      path: "*",
      element: <PageNotFound />,
      id: "pageNotFound",
      title: "Page Not Found",
      icon: <ScheduleIcon />,
      type: "item",
      roles: [],
      hide: true,
    },

    // influencer dashboard
    {
      category: "Influencer",
      path: "/influencerDashboard",
      element: <InfluencerDashboard />,
      id: "influencerDashboard",
      title: "Dashboard",
      icon: <ConnectWithoutContactIcon />,
      type: "item",
      roles: [],
    },

    //InfluencersCampaigns
    {
      category: "Influencer",
      path: "/InfluencersCampaigns",
      element: <InfluencersCampaigns />,
      id: "InfluencersCampaigns",
      title: "My Campaigns",
      icon: <GradingIcon />,
      type: "item",
      roles: [],
    },

    // mange influence user
    // {
    //   category: "Influencer",
    //   path: "/manageInfluencerUser",
    //   element: <ManageInfluencerUser />,
    //   id: "manageInfluencerUser",
    //   title: "Manage Influencers",
    //   icon: <GroupIcon />,
    //   type: "item",
    //   roles: [],
    // },
    //InfluencersAllActivity
    {
      category: "Influencer",
      path: "/InfluencersAllActivity",
      element: <InfluencersAllActivity />,
      id: "InfluencersAllActivity",
      title: "My Activity",
      icon: <AddTaskIcon />,
      type: "item",
      roles: [],
    },

    //Influencer reports
    {
      category: "Influencer",
      path: "/InfluencersReports",
      element: <InfluencerReports />,
      id: "InfluencersReports",
      title: "Reports",
      icon: <RecordVoiceOverIcon />,
      type: "item",
      roles: [],
    },

    // activity type page
    // {
    //   category: "Influencer",
    //   path: "/activityType",
    //   element: <ActivityTypeList />,
    //   id: "InfluencerActivityType",
    //   title: "Activity Type",
    //   icon: <AddTaskIcon />,
    //   type: "item",
    //   roles: [],
    // },

    // influencer page
    {
      category: "Influencer",
      path: "/influencersPlatform",
      element: <InfluencersPlatformAccount />,
      id: "influencersPlatform",
      title: "My Social Accounts",
      icon: <TravelExploreIcon />,
      type: "item",
      roles: [],
    },

    // facebook / Instagram oauth callback
    {
      category: "Influencer",
      path: "/influencer_facebook_auth_login",
      element: <FacebookCallBack />,
      id: "facebookCallBack",
      title: "Facebook Callback",
      icon: <Shop />,
      type: "item",
      roles: [],
      hide: true,
    },

    // Youtube oauth call back
    {
      category: "Influencer",
      path: "/influencer_youtube_auth_login",
      element: <YoutubeCallBack />,
      id: "youtubeCallBack",
      title: "Youtube Callback",
      icon: <Shop />,
      type: "item",
      roles: [],
      hide: true,
    },
  ],
};

export default routes;
